import { lazy, Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import RedirectLoader from '../RedirectingLoader';

import { useUser } from 'contexts/userContext';

import { ContainerApp } from '../ContainerApp';
const HomeV2 = lazy(() => import('pages/v2/home'));
const AppRoutes = lazy(() => import('../../Routes'));

const Clarity = lazy(() => import('utils/clarity'));
const GoogleAnalytics = lazy(() => import('utils/google-analytics'));
const GTM = lazy(() => import('utils/gtm'));
const MetaPixel = lazy(() => import('utils/meta-pixel'));

export function AppWrapper() {
  const { isLoading } = useUser();

  const { pathname } = useLocation();
  const isLandingPage = pathname === '/';
  // No trackers inside a call: they would record the video page and chat.
  const isMeetingPage = /^\/(meet|lobby)(\/|$)/.test(pathname);

  if (isLandingPage) {
    return (
      <ContainerApp>
        <Routes>
          <Route
            path="/"
            exact
            element={
              <Suspense fallback={<RedirectLoader />}>
                <HomeV2 />
              </Suspense>
            }
          />
        </Routes>
      </ContainerApp>
    );
  }

  if (isLoading) {
    return <RedirectLoader />;
  }

  return (
    <>
      {!isMeetingPage && (
        <Suspense fallback={null}>
          <GTM />
          <MetaPixel />
          <GoogleAnalytics />
          <Clarity />
        </Suspense>
      )}
      <Suspense fallback={<RedirectLoader />}>
        <AppRoutes />
      </Suspense>
    </>
  );
}
